var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwaitingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#F0C274"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9699 32.8542H20.0299C18.2974 32.8542 17.0324 32.13 16.5466 30.8834C16.0424 29.5817 16.5099 27.9684 17.7199 26.8775L21.9733 23L17.7199 19.1225C16.5099 18.0317 16.0424 16.4184 16.5466 15.1167C17.0324 13.8609 18.2974 13.1459 20.0299 13.1459H25.9699C27.7024 13.1459 28.9674 13.87 29.4533 15.1167C29.9574 16.4184 29.4899 18.0317 28.2799 19.1225L24.0266 23L28.2891 26.8775C29.4899 27.9684 29.9666 29.5817 29.4624 30.8834C28.9674 32.13 27.7024 32.8542 25.9699 32.8542ZM22.9999 23.9259L18.6458 27.8859C17.8758 28.5917 17.5366 29.6184 17.8299 30.3792C18.1049 31.085 18.8841 31.4792 20.0299 31.4792H25.9699C27.1158 31.4792 27.8949 31.0942 28.1699 30.3792C28.4633 29.6184 28.1333 28.5917 27.3541 27.8859L22.9999 23.9259ZM20.0299 14.5209C18.8841 14.5209 18.1049 14.9059 17.8299 15.6209C17.5366 16.3817 17.8666 17.4084 18.6458 18.1142L22.9999 22.0742L27.3541 18.1142C28.1241 17.4084 28.4633 16.3817 28.1699 15.6209C27.8949 14.915 27.1158 14.5209 25.9699 14.5209H20.0299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingicon);
export default __webpack_public_path__ + "static/media/awaitingicon.e1b46a56f117607bb729aa5e2d97044a.svg";
export { ForwardRef as ReactComponent };